// La cloche (lot 6.2) : les dernières notifications, lues ou non. En ouvrir une la marque lue et mène où elle mène ;
// une notification lue n'est pas relancée. Utile surtout sur iPhone, où une notification peut se perdre.

import { useEffect, useState } from 'react';

import type { Notification } from '@alfred/shared';
import type { Actions } from '../App';
import { EnTeteRetour } from '../components';
import { api } from '../lib/api';

function quand(iso: string): string {
  const d = new Date(iso);
  const hier = new Date(Date.now() - 86_400_000);
  const heure = d.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });
  if (d.toDateString() === new Date().toDateString()) return heure;
  if (d.toDateString() === hier.toDateString()) return `hier ${heure}`;
  return `${d.toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit' })} ${heure}`;
}

export function Notifications({ actions }: { actions: Actions }) {
  const [liste, setListe] = useState<Notification[] | null>(null);

  const charger = () => void api.notifications().then(setListe).catch((e: Error) => actions.toast({ texte: e.message, erreur: true }));
  useEffect(charger, []);

  const ouvrir = async (n: Notification) => {
    if (!n.lueLe) await api.marquerLue(n.id).catch(() => undefined);
    // Les adresses des notifications sont celles de l'app (« /#/a-valider ») : on change seulement le hash.
    const hash = `#${(n.url ?? '/#/').replace(/^\/?#?/, '') || '/'}`;
    if (window.location.hash === hash) charger();
    else window.location.hash = hash;
  };
  const toutLu = async () => {
    await api.toutMarquerLu().catch(() => undefined);
    charger();
  };

  const nonLues = liste?.filter((n) => !n.lueLe).length ?? 0;
  return (
    <main className="ecran">
      <EnTeteRetour titre="Notifications" />
      {liste === null && <p className="message muted">Chargement…</p>}
      {liste?.length === 0 && <p className="message muted">Aucune notification pour l’instant.</p>}
      {nonLues > 0 && <button className="btn" onClick={() => void toutLu()}>Tout marquer lu ({nonLues})</button>}
      <div className="liste-notifications">
        {liste?.map((n) => (
          <button key={n.id} className={`notification-ligne${n.lueLe ? '' : ' non-lue'}`} onClick={() => void ouvrir(n)}>
            <span className="t"><b>{n.titre}</b><span>{n.corps}</span></span>
            <small className="mono muted">{quand(n.creeLe)}</small>
          </button>
        ))}
      </div>
    </main>
  );
}
